import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

import { DBService } from './db.service';

@Injectable()
export class AdminAuthService {
  private admin: firebase.User;  //Authenticated User
  private adminObservable: Observable<firebase.User>;
  private adminUser;
  private profilePicUrl;

  constructor(
    private afAuth: AngularFireAuth,
    private dbService: DBService
  ) { }


  setAdmin(admin) {
    this.admin = admin;
  }

  clearAdmin() {
    this.admin = null;
  }

  getAdmin() {
    return this.admin;
  }

  getAdminUser() {
    let obs = Observable.create();
    this.afAuth.authState.subscribe( fbUser => {
      this.dbService.getMember(fbUser.uid).subscribe( user => {
        obs.next(user);
      });
    });

    return obs;
  }

  logoutAdmin() {
    this.afAuth.auth.signOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-auth.service.ts